<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.00018 14.6667H4.00002C3.6464 14.6667 3.30726 14.5262 3.05721 14.2762C2.80716 14.0261 2.66669 13.687 2.66669 13.3334V2.66671C2.66669 2.31309 2.80716 1.97395 3.05721 1.7239C3.30726 1.47385 3.6464 1.33337 4.00002 1.33337H8.66669L13.3334 6.00004V8.00037"
            stroke="#A1A8B8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M8.66669 1.33337V6.00004H13.3334" stroke="#A1A8B8" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        <g clip-path="url(#clip0_8821_2869)">
            <path
                d="M10.6667 14.333C12.1394 14.333 13.3332 13.1392 13.3332 11.6665C13.3332 10.1938 12.1394 9 10.6667 9C9.19403 9 8.00018 10.1938 8.00018 11.6665C8.00018 13.1392 9.19403 14.333 10.6667 14.333Z"
                stroke="#A1A8B8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M13.9994 15L12.5495 13.55" stroke="#A1A8B8" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_8821_2869">
                <rect width="7.99957" height="7.99957" fill="white" transform="translate(7 8)" />
            </clipPath>
        </defs>
    </svg>
</template>
    
<script>
export default {

}
</script>